import { RepositoryFactory } from "@/data/repositories/repositoryFactory";

const repository = () => RepositoryFactory.get("invoiceRule");

// initial state
const state = {
    invoiceRules: []
};

// getters
const getters = {};

// actions
const actions = {
    async getInvoiceRules({ commit }) {
        const response = await repository().getInvoiceRules();
        commit("SET_INVOICE_RULES", response.data.item);
    },
    async createRule({ commit }, rule) {
        const response = await repository().createRule(rule);
        commit("ADD_INVOICE_RULE", response.data.item);
        return response.data.item;
    },
    async updateRule({ commit }, rule) {
        await repository().updateRule(rule.id, rule);
        commit("UPDATE_INVOICE_RULE", rule);
    },
    async deleteRule({ commit }, id) {
        await repository().deleteRule(id);
        commit("REMOVE_INVOICE_RULE", id);
    }
};

// mutations
const mutations = {
    SET_INVOICE_RULES(state, invoiceRules) {
        state.invoiceRules = invoiceRules;
    },
    ADD_INVOICE_RULE(state, rule) {
        state.invoiceRules = [...state.invoiceRules, rule];
    },
    UPDATE_INVOICE_RULE(state, updatedRule) {
        state.invoiceRules = state.invoiceRules.map(r =>
            r.id === updatedRule.id ? updatedRule : r
        );
    },
    REMOVE_INVOICE_RULE(state, id) {
        state.invoiceRules = state.invoiceRules.filter(r => r.id !== id);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
